module.exports = "pegasus_template/assets/l_d.png";